export class ApiError extends Error {
  status: number;
  errorCode?: string;

  constructor(message: string, status: number, errorCode?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.errorCode = errorCode;
  }
}

export const ESCALATION_CLOSED_ERROR_CODE = 'ESCALATION_CLOSED';

export async function apiErrorFromResponse(response: Response, fallbackMessage: string): Promise<ApiError> {
  try {
    const body = await response.json() as { error?: string; message?: string };
    return new ApiError(body.message ?? fallbackMessage, response.status, body.error);
  } catch {
    return new ApiError(fallbackMessage, response.status);
  }
}

// Store the modal opener function globally
let showTermsOutdatedModal: (() => void) | null = null;

export function setTermsOutdatedModalHandler(handler: () => void) {
  showTermsOutdatedModal = handler;
}

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set('X-Requested-With', 'XMLHttpRequest');

  const response = await fetch(input, {
    ...init,
    credentials: 'same-origin',
    headers,
  });

  // Check for terms_outdated error (403 with specific error code)
  if (response.status === 403) {
    try {
      const errorData = await response.clone().json();
      if (errorData.error === 'terms_outdated') {
        // Show modal if handler is registered
        if (showTermsOutdatedModal) {
          showTermsOutdatedModal();
        } else {
          // Fallback to alert if modal not available yet (should be rare)
          alert("We've updated our Terms and Conditions. Please sign in to review and accept.");
          // Reload to ensure modal handler gets registered
          window.location.reload();
        }
        throw new ApiError(errorData.message || 'Terms outdated', 403, 'terms_outdated');
      }
    } catch (e) {
      // If parsing fails, continue with normal error handling
      if (e instanceof ApiError) throw e;
    }
  }

  return response;
}